import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import ForgotPasswordLayout from './Layout';

const ForgotPasswordFlow = loadable(() => pMinDelay(import('./ForgotPasswordFlow'), 300), {
  fallback: <Loading />
});

const AsyncForgotPassword = props => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  if (isAuthenticated) {
    return <Redirect to='/' />;
  }

  const isDesktop = props.userAgent.device?.type === 'desktop';
  const pageConfig = {
    headerType: isDesktop ? 'login-only' : 'mobile-none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <ForgotPasswordLayout isDesktop={ isDesktop }>
        <ForgotPasswordFlow { ...props }/>
      </ForgotPasswordLayout>
    </ApplicationLayout>
  );
};

AsyncForgotPassword.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncForgotPassword;
